
import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';
import { SeasonalityAdjustmentNameColumn } from './seasonality-adjustment-name-column';
import { ScopeColumn } from './scope-column';
import { DeviceTypeColumn } from './device-type-column';
import { ConversionRateColumn } from './conversion-rate-adjustment';
import { StartTimeColumn, EndTimeColumn } from './date-column';
import { DescriptionColumn } from './description-column';
import { AdjustmentType } from '../../adjustment-type';

function isDefined(p) { return !!p; }

function getBuilder(adjustmentType) {
  const builder = new ColumnsConfigBuilder()
    .addCategory('Attributes', category => category.addColumns([
      SeasonalityAdjustmentNameColumn,
      ScopeColumn,
      DeviceTypeColumn,
      adjustmentType === AdjustmentType.SeasonalityAdjustment ? ConversionRateColumn : undefined,
      StartTimeColumn,
      EndTimeColumn,
      DescriptionColumn,
    ].filter(isDefined)))
    .setLockedColumns([
      SeasonalityAdjustmentNameColumn,
    ]).setSelectedColumns([
      ScopeColumn,
      DeviceTypeColumn,
      adjustmentType === AdjustmentType.SeasonalityAdjustment ? ConversionRateColumn : undefined,
      StartTimeColumn,
      EndTimeColumn,
    ].filter(isDefined));

  return builder;
}

export function getColumnsAndColumnChooserConfig({
  i18n,
  columnChooserPreferences: { Columns, SelectedColumns },
  inlineEditConfig,
  scope,
  adjustmentType,
}) {
  const builder = getBuilder(adjustmentType);


  const columnsConfig = builder.getColumnsConfig({
    i18n,
    inlineEditConfig,
    scope,
    adjustmentType,
  });

  const columnChooserConfig = builder.getColumnChooserConfig({
    i18n,
    Columns,
    SelectedColumns,
  });

  columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';

  return {
    columnsConfig,
    columnChooserConfig,
  };
}
